import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import ServiceServices from "../../services/ServiceServices";
import { ArrowLeft, Info } from "feather-icons-react/build/IconComponents";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import useStore from "../../store/store"; // Add this import

//Nail Services -
const AddService = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    category: "nail service",
    store: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const selectedStore = useStore((state) => state.selectedStore);

  useEffect(() => {
    // Set the store ID from selected store when component mounts
    if (selectedStore) {
      setFormData((prev) => ({
        ...prev,
        store: selectedStore._id,
      }));
    }
  }, [selectedStore]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const serviceData = {
        ...formData,
        price: parseFloat(formData.price),
        category: "nail service",
        // Ensure store is properly set
        store: formData.store, // Make sure this is the store ID, not just a name
      };

      const response = await ServiceServices.createService(
        serviceData.store,
        serviceData
      );
      console.log("Service creation response:", response); // Add this for debugging
      navigate(route.servicelist);
    } catch (err) {
      console.error("Service creation error:", err); // Add this for debugging
      setError(err.response?.data?.message || "Failed to create service");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Create Service</h4>
                <h6>Create new service</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <RefreshIcon />
              <CollapesIcon />
              <li>
                <div className="page-btn">
                  <Link to={route.servicelist} className="btn btn-secondary">
                    <ArrowLeft className="me-2" />
                    Back to Service
                  </Link>
                </div>
              </li>
            </ul>
          </div>

          <form className="add-product-form" onSubmit={handleSubmit}>
            <div className="add-product">
              <div
                className="accordions-items-seperate"
                id="accordionSpacingExample"
              >
                <div className="accordion-item border mb-4">
                  <h2 className="accordion-header" id="headingSpacingOne">
                    <div className="accordion-button collapsed bg-white">
                      <div className="d-flex align-items-center justify-content-between flex-fill">
                        <h5 className="d-flex align-items-center">
                          <Info className="text-primary me-2" />
                          <span>Service Information</span>
                        </h5>
                      </div>
                    </div>
                  </h2>
                  <div
                    id="SpacingOne"
                    className="accordion-collapse collapse show"
                  >
                    <div className="accordion-body border-top">
                      {error && (
                        <div className="alert alert-danger">{error}</div>
                      )}
                      <div className="row">
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Store<span className="text-danger ms-1">*</span>
                            </label>
                            <select
                              className="form-control"
                              name="store"
                              value={formData.store}
                              disabled // Make it readonly
                              required
                            >
                              <option value="">Select Store</option>
                              {selectedStore && (
                                <option value={selectedStore._id}>
                                  {selectedStore.name}
                                </option>
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Service Name
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Price<span className="text-danger ms-1">*</span>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="price"
                              value={formData.price}
                              onChange={handleChange}
                              required
                              min="0"
                              step="0.01"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="d-flex align-items-center justify-content-end mb-4">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={() => navigate(route.productlist)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Creating..." : "Add Service"}
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0 text-gray-9">
            2014 - 2025 © Style Buzz Pro. All Right Reserved
          </p>
          <p>
            Designed &amp; Developed by{" "}
            <Link to="#" className="text-primary">
              Dreams
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default AddService;
